import React from 'react'
import { motion } from 'framer-motion'
import { Mail, Phone, MapPin, Send } from 'lucide-react'
import { useBrand } from '../branding/BrandProvider'

const ContactPage = () => {
  const brand = useBrand()
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-4xl font-display font-bold text-white mb-4">Contact
              <span className="text-gradient block">{brand.siteName}</span>
            </h1>
            <p className="text-white/70 mb-8">Have questions, feedback, or partnership ideas? We’d love to hear from you.</p>

            <div className="space-y-4 text-white/80">
              <div className="flex items-center space-x-3"><Mail size={18} className="text-le-accent" /><span>{brand.contactEmail ?? 'hello@example.com'}</span></div>
              {brand.contactPhone && (
                <div className="flex items-center space-x-3"><Phone size={18} className="text-le-accent" /><span>{brand.contactPhone}</span></div>
              )}
              <div className="flex items-center space-x-3"><MapPin size={18} className="text-le-accent" /><span>Wichita, Kansas</span></div>
            </div>
          </motion.div>

          <motion.form className="glass-card p-8 space-y-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} onSubmit={(e) => e.preventDefault()}>
            <div>
              <label className="block text-white/80 mb-2">Name</label>
              <input className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Your name" />
            </div>
            <div>
              <label className="block text-white/80 mb-2">Email</label>
              <input type="email" className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-white/80 mb-2">Message</label>
              <textarea rows={5} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="How can we help?" />
            </div>
            <button className="btn-primary w-full flex items-center justify-center space-x-2"><Send size={18} /><span>Send Message</span></button>
          </motion.form>
        </div>
      </section>
    </div>
  )
}

export default ContactPage

